export default __webpack_public_path__ + "static/media/dashboard_careplan_session_icon.2919613c.svg";